import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Icon, Pagination } from "semantic-ui-react";
import LeaveManagementTable from "../../components/LeaveManagementTable";
import { getLeaveHistory } from "../../core/actions/leaveHistoryAction";
import functionCommon from "../../core/common/function";
import { employeeStatus } from "../../core/constant/allLeaveRequest.constants";
import { commonConstants } from "../../core/constant/common.constants";
import { leaveStatusLabel } from "../../core/constant/myLeaveRequest.constants";
import "./styles.scss";

export default function LeaveHistory() {
    const { t } = useTranslation();
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const historyTo = useHistory();
    const { history, loading, loadingPage } = useSelector((state) => state.leaveHistoryReducer);
    const initParams = {
        dayFrom: params.get("dayFrom"),
        dayTo: params.get("dayTo"),
        leaveTypeId: params.get("leaveTypeId"),
        approverId: params.get("approverId"),
        requestStatus: params.get("requestStatus"),
        employeeId: params.get("employeeId"),
        sortBy: "dayFrom-DESC",
        currentPage: 1,
        pageRecord: 20,
    };

    const getLableStatus = (status) => {
        if (status && leaveStatusLabel[status]) return t("labels." + leaveStatusLabel[status].toLowerCase());
    };

    const handleGoToDetail = (id) => () => {
        historyTo.push(
            `/all-leave-request/leave-history/detail?leaveRequestId=${id}&hasPermission=${commonConstants.HAS_PERMISSION.ALL_DETAIL_REQUEST}`
        );
    };

    const dataTable = useMemo(() => {
        const result = {
            header: [
                t("labels.leaveDate"),
                t("labels.leaveType"),
                t("labels.daysOff"),
                t("labels.hoursOff"),
                t("labels.approver"),
                t("labels.status"),
            ],
        };
        if (history.leaveHistory && history.leaveHistory.length > 0) {
            const body = [];
            history.leaveHistory.forEach((ele) => {
                body.push([
                    <a className="leave-active-link" onClick={handleGoToDetail(ele.leaveRequestId)}>{`${moment(
                        ele.dayFrom
                    ).format("DD/MM/YYYY")} - ${moment(ele.dayTo).format("DD/MM/YYYY")}`}</a>,
                    ele.leaveTypeName,
                    ele.daysOff,
                    Number(ele.hoursOff),
                    ele.approver,
                    getLableStatus(ele.requestStatus),
                ]);
            });
            result.body = body;
        }
        return result;
    }, [history.leaveHistory, t]);

    const handlePaginationChange = (e, { activePage }) => {
        setCurrentPage(activePage);
        dispatch(getLeaveHistory({ ...initParams, currentPage: activePage }, true));
    };

    useEffect(() => {
        if (!initParams || !initParams.dayFrom || !initParams.dayTo || !initParams.employeeId)
            window.location.href = "/error/404";
    }, []);

    useEffect(() => {
        dispatch(getLeaveHistory(initParams));
    }, []);

    return (
        <div className="leave-history">
            <h2 className="page-heading">
                <span onClick={functionCommon.goToPage("/my-leave-request")}>{t("labels.leaveManagemnet")}</span>
                {"/ "}
                <span onClick={functionCommon.goToPage("/all-leave-request")}>{t("labels.allLeaveRequest")}</span>
                {"/ "}
                <span onClick={functionCommon.goToPage("/all-leave-request/leave-history" + search)}>
                    {t("labels.leaveHistory")}
                </span>
            </h2>

            <div className="infomation">
                <p className="leave-title">{t("labels.employeeInformation")}</p>
                <div className="content">
                    <div className="item">
                        <label>{t("labels.employeeName")}: </label>
                        {loading ? <p>{history.employeeName}</p> : ""}
                    </div>
                    <div className="item">
                        <label>{t("labels.employeeCode")}: </label>
                        {loading ? <p>{history.employeeCode}</p> : ""}
                    </div>
                    <div className="item">
                        <label>{t("labels.employeeStatusLeave")}: </label>
                        {loading && (
                            <p>
                                {employeeStatus[history.employeeStatus] &&
                                    t("labels." + employeeStatus[history.employeeStatus])}
                            </p>
                        )}
                    </div>
                </div>
            </div>
            <div className="table">
                <p className="leave-title">{t("labels.leaveHistory")}</p>
                {loading && <LeaveManagementTable content={dataTable} customTableClass="table-custom" />}
                {history.totalPage > 0 && (
                    <div className="leave-table-paging">
                        <Pagination
                            size="tiny"
                            activePage={currentPage}
                            firstItem={null}
                            lastItem={null}
                            disabled={loadingPage}
                            totalPages={history.totalPage > 0 ? history.totalPage : null}
                            prevItem={{
                                disabled: currentPage === 1 || loadingPage,
                                content: <Icon name="chevron left" />,
                                icon: true,
                            }}
                            nextItem={{
                                disabled: currentPage === history.totalPage || loadingPage,
                                content: <Icon name="chevron right" />,
                                icon: true,
                            }}
                            onPageChange={handlePaginationChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}
